import { Col, Row } from 'antd'
import React from 'react'
import styled from 'styled-components'

const EventHeader1 = styled.div`
  width: 100%;
  padding-top: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #343e59;
`
const StyledRow = styled(Row)`
  height: 48px;
`

const RankingAlgorithm = ({ stdRankAlgoData }) => {
  const desiredOrder = [
    'Academics',
    'Internship',
    'Project',
    'TrainingCourse',
    'WorkExperience',
    'skillBucket',
  ]

  const allparametersToShow = [
    ...desiredOrder,
    ...Object.keys(
      stdRankAlgoData?.ratingDetails?.parameterDetails ?? {}
    ).filter(param => !desiredOrder?.includes(param ?? '')),
  ]

  const parametersToShow = allparametersToShow?.filter(item =>
    stdRankAlgoData?.ratingDetails?.parameterDetails?.hasOwnProperty(item)
  )

  const skillBucket = stdRankAlgoData?.ratingDetails?.skillBucket
  const capitalizeFirstLetter = str => {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)
  }

  return (
    <Row>
      <Col span={12}>
        <div style={{ padding: '20px', borderTop: '1px solid #E6E7EA' }}>
          <Row>
            <Col span={16}>
              <EventHeader1>Ranking Parameters</EventHeader1>
            </Col>
            <Col span={8}>
              <EventHeader1>Score (max 5)</EventHeader1>
            </Col>
          </Row>
          <div
            style={{
              marginTop: '20px',
              backgroundColor: '#F7F8FC',
              border: '1px solid #E6E7EA',
              borderRadius: '10px',
            }}
          >
            {parametersToShow?.map((parameter, index) => {
              const score =
                stdRankAlgoData?.ratingDetails?.parameterDetails[parameter]
              const formattedParameter = capitalizeFirstLetter(
                parameter.split(/(?=[A-Z])/).join(' ')
              ) // Add this line to format the parameter
              return (
                <div key={index + 'parameter'}>
                  <StyledRow
                    style={{
                      borderBottom:
                        index === parametersToShow?.length - 1
                          ? 'none'
                          : '1px solid #E6E7EA',
                    }}
                  >
                    <Col
                      span={16}
                      style={{
                        fontSize: '16px',
                        marginTop: '12px',
                        color: '#010E30',
                        paddingLeft: '5px',
                        fontWeight: '400',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {formattedParameter}
                    </Col>
                    <Col
                      span={8}
                      style={{
                        fontSize: '16px',
                        paddingTop: '12px',
                        color: '#010E30',
                        textAlign: 'center',
                        borderLeft: '1px solid #E6E7EA',
                        fontWeight: '400',
                      }}
                    >
                      {score !== undefined ? score?.toFixed(2) : '0.00'}
                    </Col>
                  </StyledRow>
                </div>
              )
            })}
          </div>
        </div>
      </Col>
      {skillBucket?.length > 0 && <Col span={12}>
        <div style={{ padding: '20px', borderTop: '1px solid #E6E7EA' }}>
          <Row>
            <Col span={16}>
              <EventHeader1>Skills</EventHeader1>
            </Col>
            <Col span={8}>
              <EventHeader1>Score (max 5)</EventHeader1>
            </Col>
          </Row>
          <div
            style={{
              marginTop: '20px',
              backgroundColor: '#F7F8FC',
              border: '1px solid #E6E7EA',
              borderRadius: '10px',
            }}
          >
            {skillBucket?.map((parameter, index) => {
              const formattedParameter = capitalizeFirstLetter(
                parameter?.name.split(/(?=[A-Z])/).join(' ')
              ) // Add this line to format the parameter
              return (
                <div key={index + 'skillBucket'}>
                  <StyledRow
                    style={{
                      borderBottom:
                        index === skillBucket?.length - 1
                          ? 'none'
                          : '1px solid #E6E7EA',
                    }}
                  >
                    <Col
                      span={16}
                      style={{
                        fontSize: '16px',
                        marginTop: '12px',
                        color: '#010E30',
                        paddingLeft: '5px',
                        fontWeight: '400',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {formattedParameter}
                    </Col>
                    <Col
                      span={8}
                      style={{
                        fontSize: '16px',
                        paddingTop: '12px',
                        color: '#010E30',
                        textAlign: 'center',
                        borderLeft: '1px solid #E6E7EA',
                        fontWeight: '400',
                      }}
                    >
                      {parameter?.score !== undefined
                        ? parameter?.score?.toFixed(2)
                        : '0.00'}
                    </Col>
                  </StyledRow>
                </div>
              )
            })}
          </div>
        </div>
      </Col>}
    </Row>
  )
}

export default RankingAlgorithm
